export default {
    parts: [
        'productItem',
        'skeletonWrapper',
        'skeletonContainer',
        'skeletonTitle',
        'skeletonApproaching',
        'skeletonItem',
        'skeletonSummary'
    ],
    baseStyle: {
        productItem: {
            padding: '21px',
            border: '3px solid',
            borderColor: 'white',
            margin: '0 -24px'
        },
        skeletonWrapper: {
            flex: '1'
        },
        skeletonContainer: {
            maxWidth: 'container.xl',
            px: {base: 4, lg: 6},
            paddingTop: {base: 8, lg: 8},
            paddingBottom: {base: 8, lg: 14}
        },
        skeletonTitle: {
            height: '36px',
            width: '220px',
            mb: 6
        },
        skeletonApproaching: {
            minHeight: {base: '60px', lg: '70px'},
            mb: 4
        },
        skeletonItem: {
            height: '180px',
            borderRadius: 'md'
        },
        skeletonSummary: {
            height: '420px',
            borderRadius: 'md'
        }
    }
}
